import { render, staticRenderFns } from "./LocationsManagerLandingPage.vue?vue&type=template&id=2700fca1&scoped=true&"
import script from "./LocationsManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./LocationsManagerLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./LocationsManagerLandingPage.vue?vue&type=style&index=0&id=2700fca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700fca1",
  null
  
)

export default component.exports